import React from "react";

const SignupComp = props => (
  <div>
    <form onSubmit={e => props.submit(e, "signup")}>
      <div className="form-group">
        <label>Full name</label>
        <input type="text" name="name" placeholder="Fullname" />
        {props.chk_errors("name")}
      </div>

      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          name="email"
          placeholder="Email address"
          autoComplete="new-email"
        />
        {props.chk_errors("email")}
      </div>
      <div className="form-group">
        <label>Password</label>
        <div className="credential_password">
          <input
            type={props.show_password ? "text" : "password"}
            name="password"
            placeholder="Password"
            autoComplete="new-password"
          />
          <i
            className={props.show_password ? "fa fa-eye" : "fa fa-eye-slash"}
            onClick={props.handleShowPassword}
          />
        </div>
        {props.chk_errors("password")}
      </div>
      <div className="form-group">
        <label>Confirm Password</label>
        <div className="credential_password">
          <input
            type={props.show_confirm_password ? "text" : "password"}
            name="confirm_password"
            placeholder="Confirm Password"
          />
          <i
            className={
              props.show_confirm_password ? "fa fa-eye" : "fa fa-eye-slash"
            }
            onClick={() => props.handleShowPassword("confirm")}
          />
        </div>

        {props.chk_errors("confirm_password")}
      </div>
      <div className="form-group">
        <button>Sign up</button>
      </div>
      <p>
        By continuing, you agree to our{" "}
        <a href="terms" target="_blank">
          Terms, Conditions &amp; Privacy policy
        </a>
        .
      </p>
    </form>

    <hr />

    <div>
      Already have an Heydesk account?{" "}
      <b className="signup" onClick={() => props.page("login")}>
        Log in
      </b>
    </div>
  </div>
);

export default SignupComp;
